import React, { useRef, useState, useEffect } from "react";

export default function MessageAudio(props) {
    const { objectUrl } = props.message;
    const sent = true;
    const audioRef = useRef(null);
    const canvasRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [duration, setDuration] = useState(0);
    const [currentTime, setCurrentTime] = useState(0);
    const [speed, setSpeed] = useState(1);
    const [peaks] = useState(() =>
        Float32Array.from({ length: 84 }, () => 0.2 + 0.6 * Math.random())
    );

    // Dibuja waveform
    const draw = () => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const dpr = window.devicePixelRatio || 1;
        const W = canvas.clientWidth * dpr;
        const H = canvas.clientHeight * dpr;
        canvas.width = W;
        canvas.height = H;

        const mid = H / 2;
        const gap = 3 * dpr;
        const barW = (W - (peaks.length - 1) * gap) / peaks.length;
        const played = currentTime / duration || 0;

        ctx.clearRect(0, 0, W, H);
        const baseColor = sent ? "#006affff" : "#667781";
        const bg = "rgba(0, 0, 0, 0.33)";
        const progBars = Math.floor(peaks.length * played);

        // Fondo
        ctx.fillStyle = bg;
        peaks.forEach((v, i) => {
            const h = v * H * 0.9;
            const x = i * (barW + gap);
            ctx.fillRect(x, mid - h / 2, barW, h);
        });

        // Progreso
        ctx.fillStyle = baseColor;
        for (let i = 0; i < progBars; i++) {
            const h = peaks[i] * H * 0.9;
            const x = i * (barW + gap);
            ctx.fillRect(x, mid - h / 2, barW, h);
        }
    };

    useEffect(() => {
        if (canvasRef.current) draw();
    }, [currentTime, duration, sent]);

    // Listeners del audio
    useEffect(() => {
        const audio = audioRef.current;
        const onTime = () => setCurrentTime(audio.currentTime);
        const onEnd = () => setIsPlaying(false);
        audio.addEventListener("timeupdate", onTime);
        audio.addEventListener("ended", onEnd);
        return () => {
            audio.removeEventListener("timeupdate", onTime);
            audio.removeEventListener("ended", onEnd);
        };
    }, []);

    const toggle = () => {
        const audio = audioRef.current;
        if (audio.paused) {
            audio.play();
            setIsPlaying(true);
        } else {
            audio.pause();
            setIsPlaying(false);
        }
    };

    const fmt = (s) => {
        if (!isFinite(s)) return "0:00";
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60).toString().padStart(2, "0");
        return m + ":" + sec;
    };

    const handleLoaded = () => setDuration(audioRef.current.duration);

    const seek = (e) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const frac = (e.clientX - rect.left) / rect.width;
        const t = duration * frac;
        audioRef.current.currentTime = t;
        setCurrentTime(t);
    };

    const changeSpeed = () => {
        const speeds = [1, 1.5, 2];
        const i = speeds.indexOf(speed);
        const next = speeds[(i + 1) % speeds.length];
        setSpeed(next);
        audioRef.current.playbackRate = next;
    };

    return React.createElement(
        "div",
        {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 12,
                padding: "10px 12px",
                borderRadius: 16,
                background: sent ? "#ffffffff" : "#fff",
                shadow: "0 1px 1px rgba(0,0,0,.05)",
                marginLeft: sent ? "auto" : undefined,
                marginRight: !sent ? "auto" : undefined,
                minWidth: "30vw"
            },
        },
        // Botón play/pause
        React.createElement(
            "button",
            {
                onClick: toggle,
                style: {
                    width: 38,
                    height: 38,
                    borderRadius: "50%",
                    border: "none",
                    background: "rgba(0,0,0,.05)",
                    cursor: "pointer",
                    color: sent ? "#128C7E" : "#667781",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                },
            },
            isPlaying
                ? // Ícono de pausa centrado
                React.createElement(
                    "svg",
                    {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: 18,
                        height: 18,
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                    },
                    React.createElement("path", {
                        d: "M6 19c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1H6zm9 0c-.55 0-1-.45-1-1V6c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-3z",
                    })
                )
                : // Ícono de play centrado
                React.createElement(
                    "svg",
                    {
                        xmlns: "http://www.w3.org/2000/svg",
                        width: 18,
                        height: 18,
                        viewBox: "0 0 24 24",
                        fill: "currentColor",
                    },
                    React.createElement("path", {
                        d: "M8 5v14l11-7-11-7z",
                    })
                )
        ),


        // Waveform + tiempos
        React.createElement(
            "div",
            { style: { flex: 1, display: "flex", flexDirection: "column", gap: 4 } },
            React.createElement(
                "div",
                { style: { position: "relative", width: "100%", height: 36 }, onClick: seek },
                React.createElement("canvas", { ref: canvasRef, style: { width: "100%", height: "100%" } })
            ),
            React.createElement(
                "div",
                { style: { display: "flex", justifyContent: "space-between", fontSize: 12, color: "#4d5357ff" } },
                React.createElement("span", null, fmt(currentTime)),
                React.createElement("span", null, fmt(duration))
            )
        ),

        // Botón de velocidad
        React.createElement(
            "button",
            {
                onClick: changeSpeed,
                style: {
                    minWidth: 40,
                    height: 30,
                    borderRadius: 12,
                    border: "none",
                    background: "rgba(0,0,0,.05)",
                    cursor: "pointer",
                    color: sent ? "#128C7E" : "#667781",
                    fontWeight: "bold",
                    fontSize: 13,
                },
            },
            speed + "x"
        ),

        // Elemento de audio oculto
        React.createElement("audio", {
            ref: audioRef,
            src: objectUrl,
            onLoadedMetadata: handleLoaded,
            preload: "metadata",
        })
    );
}
